import { currencyFormat, getLocalizationContext } from '@fiverr-private/localization';
import { Gql } from '@fiverr-private/dynamic_matching';
import type { SellerBriefResponse } from '../../types/SellerBriefResponse';

const DEFAULT_CURRENCY = 'USD';

export interface BudgetRange {
    min: number;
    max: number;
}

export const getBudgetRange = (budgetRangeInCents: Gql.DmBriefBudgetRange) => ({
    ...(budgetRangeInCents.min && {
        min: getBudget(budgetRangeInCents?.min),
    }),
    value: getBudget(budgetRangeInCents?.max),
});

export const getOriginalBudgetRange = (
    budgetRangeInCents: BudgetRange,
    originalBuyerBudgetRange: Gql.DmBriefMoneyRange
) => ({
    ...(originalBuyerBudgetRange.min && {
        min: getOriginalBudget(budgetRangeInCents?.min, originalBuyerBudgetRange.min, true),
    }),
    value: getOriginalBudget(budgetRangeInCents?.max, originalBuyerBudgetRange.max, true),
});

const getAmountInDollars = (usdCents: number) => usdCents / 100;

export const getBudget = (usdCents: number) => {
    const amountInDollars = getAmountInDollars(usdCents);
    const localizationContext = getLocalizationContext();
    return currencyFormat({
        localizationContext,
        value: amountInDollars,
        currencyCode: DEFAULT_CURRENCY,
        options: {
            fallbackValue: `$${Math.ceil(amountInDollars)}`,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
    });
};

export const getOriginalBudget = (
    usdCents: number,
    originalBudget: SellerBriefResponse['originalBuyerBudget'],
    isRange = false
) => {
    const fallbackValue = getBudget(usdCents);

    const { amount, currency } = originalBudget || {};
    const localizationContext = getLocalizationContext();

    const finalAmount = isRange ? Number(amount) : getAmountInDollars(Number(amount));

    const value = amount ? finalAmount : getAmountInDollars(usdCents);

    const formattedValue = currencyFormat({
        localizationContext,
        value,
        currencyCode: currency || DEFAULT_CURRENCY,
        options: {
            fallbackValue,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
    });

    return formattedValue;
};
